"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CCTP_TYPE = exports.WASM_TYPE = exports.IBC_TRANSFER_TYPE = void 0;
exports.IBC_TRANSFER_TYPE = "/ibc.applications.transfer.v1.MsgTransfer";
exports.WASM_TYPE = "/cosmwasm.wasm.v1.MsgExecuteContract";
exports.CCTP_TYPE = "/circle.cctp.v1.MsgDepositForBurn";
//# sourceMappingURL=cosmos.js.map